import { Controller } from "@hotwired/stimulus"
import { useDebounce, useHotkeys } from "stimulus-use"

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["query", "form"]
  static outlets = ["sidebar"]
  static debounces = ["process"]
  static values = { sidebarPath: String }

  connect() {
    useDebounce(this, { wait: 1000 })
    useHotkeys(this, {
      "/": [this.focusSearch],
    })
  }

  process() {
    this.submitToFilterbar()
  }

  submit(event) {
    if (this.submitToFilterbar()) {
      event.preventDefault()
    }
  }

  // If a filterbar is present, submit the search query to it so that it can be applied together with any filters. Otherwise, submit the search form as normal.
  submitToFilterbar() {
    const filterbarForm = document.getElementById("filterbarForm")

    if (filterbarForm) {
      const hiddenQuery = filterbarForm.querySelector('input[name="query"]')
      if (hiddenQuery) {
        hiddenQuery.value = this.queryTarget.value
      }
      filterbarForm.requestSubmit()
      return true
    }

    this.formTarget.requestSubmit()
    return false
  }

  toggleSidebar() {
    if (this.hasSidebarOutlet) {
      this.sidebarOutlet.toggle()
    } else if (this.hasSidebarPathValue) {
      document.querySelector("#sidebar").src = this.sidebarPathValue
    }
  }

  focusSearch(event) {
    event.preventDefault()
    this.queryTarget.focus()
    this.queryTarget.select()
  }
}
